// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__17WQJ","card":"Cards_card__Xa-Wq","infected":"Cards_infected__2hepX","recovered":"Cards_recovered__3dTyt","deaths":"Cards_deaths__8x9V3"};